import React from "react";
import "./Footer.css";

export default function Footer() {
  return (
    <small className="Footer">
      <br />
      <a
        href="https://github.com/psyjulga/react-weather-app"
        target="_blank"
        rel="noreferrer"
        className="github-link"
        title="open source code on github"
      >
        Open-source code
      </a>
      🐞by Julia Bestgen💃
    </small>
  );
}
